import defaultProfileImage from "../assets/images/icons/default-profile-image.svg";
import { API_URL } from "../http";

export const setProfileImage = (profileImagePath: string | null | undefined) => {
  if (!profileImagePath) {
    return defaultProfileImage;
  } else {
    return API_URL + profileImagePath;
  }
};
